import { render } from "./ModalGuardarPeso.vue?vue&type=template&id=5ea857e0&scoped=true"
import script from "./ModalGuardarPeso.vue?vue&type=script&lang=js"
export * from "./ModalGuardarPeso.vue?vue&type=script&lang=js"

import "./ModalGuardarPeso.vue?vue&type=style&index=0&id=5ea857e0&scoped=true&lang=css"

import exportComponent from "/home/franco/Desarrollos/NC/gramosDev/Gramos/FrontEnd/trunk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ea857e0"]])

export default __exports__